import moment from "moment";
import isEmpty from "lodash/isEmpty";
import { store } from "@/store";

// Constants
const slotStartTime = moment("10:00", "HH:mm");
const slotEndTime = moment("17:30", "HH:mm");
export const NO_TIMESLOT_TEXT = "No Slots Available";

export const getSlotFromTime = (time) => {
    const slotFromTime = {
        "10:00": "10:00-10:30",
        "10:30": "10:30-11:00",
        "11:00": "11:00-11:30",
        "11:30": "11:30-12:00",
        "12:00": "12:00-12:30",
        "12:30": "12:30-01:00",
        "01:00": "01:00-01:30",
        "01:30": "01:30-02:00",
        "02:00": "02:00-02:30",
        "02:30": "02:30-03:00",
        "03:00": "03:00-03:30",
        "03:30": "03:30-04:00",
        "04:00": "04:00-04:30",
        "04:30": "04:30-05:00",
        "05:00": "05:00-05:30",
        "05:30": "05:30-06:00",
    };

    return slotFromTime[time] || "NA";
};

export const getTimeFromSlot = (slot) => {
    const timeFromSlot = {
        "10:00-10:30": { fromTime: "10:00:00", toTime: "10:30:00" },
        "10:30-11:00": { fromTIme: "10:30:00", toTime: "11:00:00" },
        "11:00-11:30": { fromTime: "11:00:00", toTime: "11:30:00" },
        "11:30-12:00": { fromTime: "11:30:00", toTime: "12:00:00" },
        "12:00-12:30": { fromTime: "12:00:00", toTime: "12:30:00" },
        "12:30-01:00": { fromTime: "12:30:00", toTime: "13:00:00" },
        "01:00-01:30": { fromTime: "13:00:00", toTime: "13:30:00" },
        "01:30-02:00": { fromTime: "13:30:00", toTime: "14:00:00" },
        "02:00-02:30": { fromTime: "14:00:00", toTime: "14:30:00" },
        "02:30-03:00": { fromTime: "14:30:00", toTime: "15:00:00" },
        "03:00-03:30": { fromTime: "15:00:00", toTime: "15:30:00" },
        "03:30-04:00": { fromTime: "15:30:00", toTime: "16:00:00" },
        "04:00-04:30": { fromTime: "16:00:00", toTime: "16:30:00" },
        "04:30-05:00": { fromTime: "16:30:00", toTime: "17:00:00" },
        "05:00-05:30": { fromTime: "17:00:00", toTime: "17:30:00" },
        "05:30-06:00": { fromTime: "17:30:00", toTime: "18:00:00" },
    };
    return timeFromSlot[slot];
};

const slotMapper = (timeSlots) => {
    return timeSlots.map((item) => {
        let slot = moment(item, "hh:mm");
        return `${slot.format("hh:mm")}-${slot.add(30, "minute").format("hh:mm")}`;
    });
};

const getAllTimeSlots = (start, end, currDate) => {
    var startTime = moment(start, "hh:mm");
    var endTime = moment(end, "hh:mm");

    var timeSlots = [];

    while (startTime <= endTime) {
        timeSlots.push(new moment(startTime).format("hh:mm"));
        startTime.add(30, "minutes");
    }
    const slotsToRemove = slotsToDelete(currDate);
    const updatedTimeSlot = differenceInArray(timeSlots, slotsToRemove);
    return updatedTimeSlot;
};

export const mapToNearestSlot = (time) => {
    const formattedTime = time ? moment(time, "HH:mm") : moment();
    const hour = formattedTime.format("HH");
    const mins = formattedTime.format("mm");
    if (Number(mins) >= 30) {
        return moment(Number(hour) + 1 + ":00", "HH:mm");
    } else {
        return moment(hour + ":30", "HH:mm");
    }
};

const getRemainingTimeSlots = (startTime, endTime, currTime, currDate) => {
    if (!(moment(currTime, "HH") <= moment(endTime, "HH"))) {
        return [];
    }

    var filteredCurrTime;
    if (startTime > currTime) {
        filteredCurrTime = mapToNearestSlot(moment(startTime, "hh:mm").add(-1, "minutes"));
    } else {
        filteredCurrTime = mapToNearestSlot(moment(currTime, "hh:mm"));
    }

    var filteredEndTime = moment(endTime, "hh:mm");
    var timeSlots = [];

    while (filteredCurrTime <= filteredEndTime) {
        timeSlots.push(new moment(filteredCurrTime).format("hh:mm"));
        filteredCurrTime.add(30, "minutes");
    }
    const slotsToRemove = slotsToDelete(currDate);
    const updatedTimeSlot = differenceInArray(timeSlots, slotsToRemove);
    return updatedTimeSlot;
};

export const getAvailableMeetingSlots = (startTime, endTime, currTime, currDate) => {
    const slots =
        moment().format("YYYY-MM-DD") === currDate
            ? getRemainingTimeSlots(
                  moment(startTime, "HH:mm"),
                  moment(endTime, "HH:mm"),
                  moment(currTime, "HH:mm"),
                  currDate
              )
            : getAllTimeSlots(moment(startTime, "HH:mm"), moment(endTime, "HH:mm"), currDate);

    return slotMapper(slots);
};

const slotsToDelete = (enteredDate) => {
    const counsellorMeeting = store.getState().meetings.counsellorMeetings;
    const slotLists =
        counsellorMeeting &&
        counsellorMeeting.length > 0 &&
        counsellorMeeting.reduce((requiredArr, currentMeeting) => {
            const istStartTime = moment(currentMeeting.from_datetime).add(5.5, "hours");
            const meetingDate = istStartTime.format("YYYY-MM-DD");
            const meetingTime = istStartTime.format("hh:mm");
            if (meetingDate === enteredDate) requiredArr.push(meetingTime);
            return requiredArr;
        }, []);

    return slotLists;
};

const differenceInArray = (array, array2) => {
    return (
        array &&
        array.length > 0 &&
        array.filter((firstArrayElem) => {
            return !(
                array2 &&
                array2.length > 0 &&
                array2.some((secondArrayElem) => secondArrayElem === firstArrayElem)
            );
        })
    );
};

export const timeSlotOptions = (currDate, showCounsellorSlots) => {
    const sunday = new Date(currDate);
    if (currDate && moment(currDate).startOf("day").isBefore(moment().startOf("day")))
        return [NO_TIMESLOT_TEXT];

    if (sunday && currDate && sunday.getDay() === 0) return [NO_TIMESLOT_TEXT];

    const currTime = moment().format("HH:mm");
    const availableSlots = getAvailableMeetingSlots(slotStartTime, slotEndTime, currTime, currDate);

    if (!isEmpty(showCounsellorSlots)) {
        showCounsellorSlots.forEach((meet) => {
            if (meet.meetingDate === currDate) {
                if (!availableSlots.find((slot) => slot.split("-")[0] === meet.meetingTime)) {
                    availableSlots.push(getSlotFromTime(meet.meetingTime));
                }
            }
        });
    }
    return availableSlots.length != 0 ? availableSlots : [NO_TIMESLOT_TEXT];
};

export const getFormDetailsFromMeetingDetails = ({ from_datetime, meeting_type }) => {
    const istDate = moment(from_datetime).add(5.5, "hours");
    const fromDateTime = istDate.toDate();
    const date = moment(fromDateTime).format("YYYY-MM-DD");
    let timeSlot = "";
    const startTime = istDate.format("hh:mm");
    timeSlot = getSlotFromTime(startTime);
    const startMeetTime = moment(istDate).format("LT");
    const meetDay = moment(istDate).format("dddd");
    const meetStart = moment(istDate).format("Do MMM");

    return {
        meeting_date: date,
        meeting_time: startMeetTime,
        meeting_day: meetDay,
        time_slot: timeSlot,
        meeting_type: meeting_type,
        meeting_start: meetStart,
    };
};

export const getDataWithCorrectTimeSlot = (selectedData, allowFutureDate = false, showCounsellorSlots) => {
    if (!selectedData || !selectedData.time_slot || !selectedData.meeting_date) return selectedData;

    let data = { ...selectedData };
    const startOfToday = moment().startOf("day"),
        startOfSelectedDate = moment(data.meeting_date).startOf("day"),
        nextMeetingDate = moment().add(startOfToday.day() === 6 ? 2 : 1, "day"),
        timeSlots = timeSlotOptions(data.meeting_date, showCounsellorSlots);

    if (startOfSelectedDate.isBefore(startOfToday) || startOfSelectedDate.day() === 0) {
        data.time_slot = NO_TIMESLOT_TEXT;
    } else if (startOfSelectedDate.isAfter(startOfToday)) {
        data.time_slot = data.time_slot === NO_TIMESLOT_TEXT ? getSlotFromTime("10:00") : data.time_slot;
    } else if (startOfSelectedDate.isSame(startOfToday) && timeSlots[0] === NO_TIMESLOT_TEXT) {
        data.meeting_date = allowFutureDate ? nextMeetingDate.format("YYYY-MM-DD") : data.meeting_date;
        data.time_slot = allowFutureDate
            ? getDataWithCorrectTimeSlot(data, false, showCounsellorSlots).time_slot
            : NO_TIMESLOT_TEXT;
    } else if (!timeSlots.some((slots) => slots === data.time_slot)) {
        data.time_slot = getSlotFromTime(mapToNearestSlot().format("hh:mm"));
    }

    return data;
};

export const getMeetingDetailsFromForm = ({ meeting_date, time_slot, meeting_type, ...others }) => {
    const timeSlot = getTimeFromSlot(time_slot);
    let fromTime = timeSlot.fromTime,
        toTime = timeSlot.toTime;

    const from_datetime = moment(`${meeting_date} ${fromTime}`, "YYYY-MM-DD HH:mm:ss").format();
    const to_datetime = moment(`${meeting_date} ${toTime}`, "YYYY-MM-DD HH:mm:ss").format();

    return {
        ...others,
        from_datetime,
        to_datetime,
        meeting_type: meeting_type || "VIRTUAL",
    };
};
